var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "pf-grid pf-grid--2" },
      [
        _c("BaseCombobox", {
          attrs: {
            label: "Tipo*",
            name: "type",
            items: _vm.types,
            "item-text": "name",
            "item-value": "id",
            rules: "required|combobox_required",
            validationErrors: _vm.errors,
          },
          model: {
            value: _vm.type,
            callback: function ($$v) {
              _vm.type = $$v
            },
            expression: "type",
          },
        }),
        _c("BaseDatePicker", {
          attrs: {
            label: "Fecha de pago*",
            name: "payment_date",
            rules: "required",
            validationErrors: _vm.errors,
          },
          model: {
            value: _vm.value.payment_date,
            callback: function ($$v) {
              _vm.$set(_vm.value, "payment_date", $$v)
            },
            expression: "value.payment_date",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "pf-section-title" }, [_vm._v("Período")]),
    _c(
      "div",
      {
        staticClass: "pf-grid",
        class: _vm.isBiweekly ? "pf-grid--3" : "pf-grid--2",
      },
      [
        _vm.isBiweekly
          ? _c("BaseCombobox", {
              attrs: {
                label: "Quincena*",
                name: "period_number",
                items: _vm.biweekly_numbers,
                "item-text": "name",
                "item-value": "id",
                rules: "required|combobox_required",
                validationErrors: _vm.errors,
              },
              model: {
                value: _vm.period_number,
                callback: function ($$v) {
                  _vm.period_number = $$v
                },
                expression: "period_number",
              },
            })
          : _vm._e(),
        _c("BaseCombobox", {
          attrs: {
            label: "Mes*",
            name: "period_month",
            items: _vm.months,
            "item-text": "name",
            "item-value": "id",
            rules: "required|combobox_required",
            validationErrors: _vm.errors,
          },
          model: {
            value: _vm.period_month,
            callback: function ($$v) {
              _vm.period_month = $$v
            },
            expression: "period_month",
          },
        }),
        _c("BaseCombobox", {
          attrs: {
            label: "Año*",
            name: "period_year",
            items: _vm.years,
            rules: "required",
            validationErrors: _vm.errors,
          },
          model: {
            value: _vm.value.period_year,
            callback: function ($$v) {
              _vm.$set(_vm.value, "period_year", $$v)
            },
            expression: "value.period_year",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }